<template>
  <component :is="component"></component>
</template>
<script>

import Func138TrocarSenha from '@/views/138/Func138TrocarSenha'

export default {
  name: 'Func138',
  data () {
    return {
      component: Func138TrocarSenha
    }
  }
}
</script>
